export const managerUsers = {
  usersList: {
    title: "Registrierte Benutzer",
    subtitle: "Liste der auf der Plattform registrierten Benutzer.",
    columns: {
      id: "ID",
      name: "Name",
      phone: "Telefon",
      email: "E-Mail",
      accommodations: "Unterkünfte",
      sends: "Sendungen",
      checkin: "Check-in",
      registeredAt: "Registrierungsdatum",
    },
    states: {
      demo: "Demoversion",
      demoEnded: "Demo beendet",
      subscribed: "Abonniert",
      subscriptionExpired: "Abonnement abgelaufen",
      queryError: "Abfragefehler",
    },
    deleteAdvisor: {
      confirmMessage: "Möchten Sie diesen Berater wirklich löschen?",
      confirmHeader: "Bestätigen",
    },
  },
  accommodationUser: {
    info: "Unterkunftsdetails",
  },
  dataUserOld: {
    accommodationsList: "Liste der Unterkünfte",
    createAccommodation: "Unterkunft anlegen",
    emptyMessage: "Keine Unterkünfte registriert",
    emptySubMessage: "Hier erscheinen die vom Benutzer registrierten Unterkünfte.",
  },
  checkins: {
    title: "Abgeschlossene Check-ins",
  },
  checkinsPending: {
    title: "Ausstehende oder laufende Check-ins",
  },
};
